/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 *
 * Portions derived from Grist (Copyright Grist Labs), used under the Apache
 * License, Version 2.0. See the NOTICE file for details.
 */

import { GristDoc } from "app/client/components/GristDoc";
import { ViewSectionRec } from "app/client/models/entities/ViewSectionRec";
import { CustomSectionConfig } from "app/client/ui/CustomSectionConfig";
import { ICustomWidget } from "app/common/CustomWidget";

export class PredefinedCustomSectionConfig extends CustomSectionConfig {
  constructor(section: ViewSectionRec, gristDoc: GristDoc) {
    super(section, gristDoc);
  }

  public buildDom() {
    return this._customSectionConfigurationConfig.buildDom();
  }

  protected shouldRenderWidgetSelector(): boolean {
    return false;
  }

  protected async _getWidgets(): Promise<ICustomWidget[]> {
    return [];
  }
}
